module.exports = __webpack_public_path__ + "img/cocotaps.b0d5938a.png";